import axios from 'axios';
import apiConfig from '../api.config';

export default function setFormsVersion(hotelId, formVersion) {
  const {
    host,
    URIs: { setFormsVersion },
  } = apiConfig;

  const uri = `${host}${setFormsVersion.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, JSON.stringify({ formVersion: formVersion }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
